module.exports = __webpack_public_path__ + "static/media/avatar4.b0f83974.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatars/avatar4.png
// module id = 38
// module chunks = 0